import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';

import Home from '../views/UnitedKingdom';
import SEO from '../components/Head';
import LayoutRaw from '../components/Layout/Layout';
import { HtmlOverflowUnset } from '../views/UnitedKingdom/styled';

interface ContextType {
  locale: string;
  name: string;
}

const IndexPage: FC<PageProps<Queries.HomeQueryQuery, ContextType>> = props => {
  const { pageContext, data } = props;

  return (
    <>
      <HtmlOverflowUnset />
      <LayoutRaw>
        <Home data={data} locale={pageContext.locale} />
      </LayoutRaw>
    </>
  );
};

export const Head: HeadFC<Queries.HomeQueryQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query UkHomeQuery($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/home/**" }) {
      childJson {
        ...Meta
        ...SeoHeader
        ...SeoWallet
      }
    }
  }
`;

export default IndexPage;
